import Vue from "vue";
import { mapGetters } from "vuex";
import { ResourceLibrarySideMenu } from "@/components/SubMenus";
import { LoadingSpinner, PaginationText } from "@/components";
import { ListLayout } from "@/components/layouts";
import { paginationMixin } from "@/components/mixins";
import { ErrorLogService } from "@/services/ErrorLogService";
import { ResourceLibraryService } from "@/services/ResourceLibraryService";
import { stringHelper } from "@/components/mixins/stringHelper";
import { MediaService } from "@/services/";
import { controlsHelper } from "@/components/mixins/commonControlsHelper";
import {constants}           from "@/const" ;


export default Vue.extend({
  name: "ResourceLibrary",
  components: {
    ResourceLibrarySideMenu,
    LoadingSpinner,
    ListLayout,
    PaginationText
  },
  mixins: [paginationMixin, stringHelper, controlsHelper],
  props: {
    resourceLabelId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    searchInput: '',
    searchText: '',
    resourceLibraryLoading: true,
    searchResults: [],
    allResults: [], // Store all results for filtering
    uniqueMediaLabels: [],
    selectedLabel: null,
    selectedResultsPerPage: 10,
    currentPageNumber: 1,
    resultsPerPage: constants.RESULTS_PER_PAGE
  }),
  computed: {
    ...mapGetters([
      "user",
      "getContentItem",
      "activeAccountId",
      "McfCostCenterId",
      "audienceIds"
    ]),
    paginatedResults() {
      const start = (this.currentPageNumber - 1) * this.selectedResultsPerPage;
      const end = start + this.selectedResultsPerPage;
      return this.searchResults.slice(start, end);
    },
  },
  created() {
    this.loadResourceLibrary();
  },
  methods: {
    getUniqueMediaLabels() {
      // Use allResults to get all possible labels
      const labels = this.allResults
        .flatMap((item: any) => Array.isArray(item.MediaLabel) ? item.MediaLabel : [])
        .filter((label: string | undefined) => !!label)
        .sort((a: string, b: string) => a.localeCompare(b));
      this.uniqueMediaLabels = Array.from(new Set(labels));
    },
    selectLabel(label: string) {
      if (this.selectedLabel === label) {
        this.selectedLabel = null;
      } else {
        this.selectedLabel = label;
      }
      this.filterResultsByLabels();
    },

    filterResultsByLabels() {
      if (!this.selectedLabel) {
        this.searchResults = this.allResults;
      } else {
        this.searchResults = this.allResults.filter((item: any) =>
          Array.isArray(item.MediaLabel) &&
          item.MediaLabel.includes(this.selectedLabel)
        );
      }
    },

    downloadLink(fileId) {
      return MediaService.getMediaUrl(fileId);
    },

    onSearch() {
      this.loadResourceLibrary(this.searchInput);
    },
    loadResourceLibrary: function (searchTerm = "") {
      this.resourceLibraryLoading = true
      var params = {
        CostCenterId: this.McfCostCenterId,
        AccountId: this.activeAccountId,
        UserId: this.user?.UserId,
        UserAudiences: this.audienceIds,
        SearchTerm: searchTerm
      }

      return ResourceLibraryService.DocumentSearch(params)
        .then(results => {
          this.allResults = results;
          this.searchResults = results;
          this.filterResultsByLabels();
          this.getUniqueMediaLabels();
          this.searchText = searchTerm;
          return results;
        })
        .catch(err => {
          ErrorLogService.LogException(err);
          return [];
        })
        .finally(() => {
          this.resourceLibraryLoading = false
        })
    },
    resultsPerPageSelected(){ 
        this.currentPageNumber = 1; // Reset to first page when changing page size
        this.$emit("resultsPerPageChanged", this.selectedResultsPerPage)
        this.loadResourceLibrary(this.searchInput);
      },
    performNextPageResourceSearch() {
        this.resourceLibraryLoading = true;
        this.loadResourceLibrary(this.searchInput);
      },
      goToPage(pageNumber: number) {
  this.currentPageNumber = pageNumber;
},

nextPage() {
  if (this.currentPageNumber < this.totalPages) {
    this.currentPageNumber++;
  }
},

previousPage() {
  if (this.currentPageNumber > 1) {
    this.currentPageNumber--;
  }
}
  }
});